import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLogin.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();

  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/adminpanel', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError('');
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.username.trim() || !formData.password) {
      setError('Please enter both username and password.');
      return;
    }

    setLoading(true);
    setError('');

    login(formData.username.trim(), formData.password).then((result) => {
      if (result.success) {
        navigate('/adminpanel', { replace: true });
      } else {
        setError(result.error);
        setLoading(false);
      }
    });
  };




  return (
    <div className="al-root">
      {/* Animated background */}
      <div className="al-bg">
        <div className="al-particle al-p1" />
        <div className="al-particle al-p2" />
        <div className="al-particle al-p3" />
        <div className="al-particle al-p4" />
        <div className="al-grid-overlay" />
      </div>

      <div className="al-wrapper">
        {/* Left branding panel */}
        <div className="al-left">
          <div className="al-left-content">
            <div className="al-left-logo">
              <img src="/assets/image/logo.png" alt="Revival Pharmacy" />
            </div>
            <h1 className="al-left-title">Revival Pharmacy</h1>
            <p className="al-left-sub">Admin Control Center</p>
            <div className="al-left-features">
              <div className="al-feature">
                <span className="al-feature-icon"><i className="fa fa-shield" /></span>
                <span>Secure & Encrypted Access</span>
              </div>
              <div className="al-feature">
                <span className="al-feature-icon"><i className="fa fa-tachometer" /></span>
                <span>Real-time Dashboard</span>
              </div>
              <div className="al-feature">
                <span className="al-feature-icon"><i className="fa fa-cogs" /></span>
                <span>Full Site Management</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right login form */}
        <div className="al-right">
          <div className="al-card">
            <div className="al-card-header">
              <div className="al-admin-badge">
                <i className="fa fa-user-secret" />
              </div>
              <h2>Admin Login</h2>
              <p>Enter your credentials to access the panel</p>
            </div>

            <form className="al-form" onSubmit={handleSubmit} noValidate>
              {error && (
                <div className="al-error-banner">
                  <i className="fa fa-exclamation-triangle" /> {error}
                </div>
              )}

              <div className="al-field">
                <label htmlFor="al-username">
                  <i className="fa fa-user" /> Username
                </label>
                <input
                  id="al-username"
                  type="text"
                  name="username"
                  className="al-input"
                  placeholder="Enter admin username"
                  value={formData.username}
                  onChange={handleChange}
                  autoComplete="username"
                  autoFocus
                />
              </div>

              <div className="al-field">
                <label htmlFor="al-password">
                  <i className="fa fa-lock" /> Password
                </label>
                <div className="al-input-wrap">
                  <input
                    id="al-password"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    className="al-input"
                    placeholder="Enter admin password"
                    value={formData.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="al-eye"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label="Toggle password"
                  >
                    <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} `} />
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="al-submit"
                id="admin-login-submit"
                disabled={loading}
              >
                {loading ? (
                  <><span className="al-spinner" /> Authenticating&hellip;</>
                ) : (
                  <><i className="fa fa-sign-in" /> Access Admin Panel</>
                )}
              </button>
            </form>

            <div className="al-card-footer">
              <a href="/" className="al-back">
                <i className="fa fa-arrow-left" /> Back to Website
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
